import { render } from "./invoice-tab.vue?vue&type=template&id=18208c52"
import script from "./invoice-tab.vue?vue&type=script&lang=js"
export * from "./invoice-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__